export default __webpack_public_path__ + "static/media/contactimg.269c0cc7.svg";